module.exports = __webpack_public_path__ + "img/valencia.9694652c.png";